import {useContext} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import AtomButton, {atomButtonDesigns, atomButtonSizes} from '@s-ui/react-atom-button'
import Context from '@s-ui/react-context'

import {getFinancedPriceClass, getValueFormated, getVerticalClass} from './utils.js'

export const CardAdPriceFinanced = ({
  financedPrice,
  handleScrollToB2cFinancingPanel,
  handleScrollToFinancingTerms,
  instalmentPrice,
  isExtended,
  isGridLayout = false,
  isTopSpaced = false,
  vertical
}) => {
  const {domain, i18n} = useContext(Context)

  const config = domain.get('config')
  const {TRACKING_EVENT_NAMES} = config.get('tracking')

  const instalmentInfoAvailable = Boolean(instalmentPrice)

  const notAvailableInstalment = !instalmentInfoAvailable && isExtended
  const showFinancedPrice = instalmentInfoAvailable

  const showConditionsApply = !instalmentInfoAvailable && isExtended

  const financingInfo = instalmentInfoAvailable ? getValueFormated(instalmentPrice) : getValueFormated(financedPrice)

  const financedCuotaClass = cx(
    'mt-CardAdPrice-financedAmountCuota',
    isTopSpaced && 'mt-CardAdPrice-financedAmountCuota--topSpaced'
  )

  const getFooterButtonProps = () => {
    return {
      children: i18n.t('COMMON.KNOW_MORE'),
      onClick: () => handleScrollToB2cFinancingPanel({event: TRACKING_EVENT_NAMES.FINANCING_CALCULATOR_CLICKED})
    }
  }

  return (
    <div
      className={getVerticalClass({
        className: 'mt-CardAdPrice-financed',
        isVertical: vertical && isExtended
      })}
    >
      <div className={getFinancedPriceClass(notAvailableInstalment)}>
        <span className="mt-CardAdPrice-financedLabel">
          {i18n.t(isGridLayout ? 'COMMON.FINANCED' : 'CARD_AD_FINANCED')}
        </span>
        <span className="mt-CardAdPrice-financedLabel">
          : <strong>{i18n.c(financedPrice)}</strong>
        </span>
      </div>
      <p className={financedCuotaClass}>
        {showFinancedPrice && financingInfo}
        {instalmentInfoAvailable && (
          <span className="mt-CardAdPrice-instalment">/{i18n.t('COMMON.PLURALS.MONTH', 1).toLowerCase()}*</span>
        )}
      </p>
      {showConditionsApply && (
        <span className="mt-CardAdPrice-financedFooter">{i18n.t('COMMON.CONDITIONS_APPLY')}</span>
      )}
      {isExtended && instalmentInfoAvailable && (
        <div className="mt-CardAdPrice-extendedFooter">
          <AtomButton design={atomButtonDesigns.LINK} size={atomButtonSizes.MEDIUM} {...getFooterButtonProps()} />
        </div>
      )}
    </div>
  )
}
CardAdPriceFinanced.propTypes = {
  financedPrice: PropTypes.number,
  handleScrollToB2cFinancingPanel: PropTypes.func,
  handleScrollToFinancingTerms: PropTypes.func,
  isFdaCalculatorB2cAvailable: PropTypes.bool,
  instalmentPrice: PropTypes.number,
  isExtended: PropTypes.bool,
  isGridLayout: PropTypes.bool,
  isTopSpaced: PropTypes.number,
  vertical: PropTypes.bool
}
